import { useState, useEffect } from 'react';
import { Box, TextField } from '@mui/material';
import { addMonths, subDays } from 'date-fns';

interface DateRangeSelectorProps {
  onDateChange: (fromDate: Date, toDate: Date) => void;
}

const DateRangeSelector = ({ onDateChange }: DateRangeSelectorProps) => {  
  const [fromDate, setFromDate] = useState<Date>(() => {
    const today = new Date();
    return addMonths(today, -2); // 2 months ago
  });
  const [toDate, setToDate] = useState<Date>(() => {
    const today = new Date();
    return subDays(today, 1); // yesterday
  });
  const [isDateChanged, setIsDateChanged] = useState(false);

  useEffect(() => {
    if (isDateChanged) {
      onDateChange(fromDate, toDate);
      setIsDateChanged(false);
    }
  }, [fromDate, toDate, isDateChanged]);

  useEffect(() => {
    const today = new Date();
    setFromDate(addMonths(today, -2));
    setToDate(subDays(today, 1));
    setIsDateChanged(true);
  }, []);

  function changeDate(date: Date, type: 'from' | 'to') {
    if (type === 'from') {
      setFromDate(date);
    } else {
      setToDate(date);
    }
    setIsDateChanged(true);
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
      <TextField
        label="From Date"
        type="date"
        value={fromDate.toISOString().split('T')[0]}
        onChange={(e) => changeDate(new Date(e.target.value), 'from')}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
        label="To Date"
        type="date"
        value={toDate.toISOString().split('T')[0]}
        onChange={(e) => changeDate(new Date(e.target.value), 'to')}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </Box>
  );
};

export default DateRangeSelector;
